import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import translations from '../i18n/translations';

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

const STORAGE_KEY = 'ldc_lang';

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return 'es';
    return localStorage.getItem(STORAGE_KEY) || (navigator.language?.startsWith('en') ? 'en' : 'es');
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, lang); } catch (e) { /* noop */ }
    if (typeof document !== 'undefined') document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    if (l === 'es' || l === 'en') setLangState(l);
  };

  // t('section.key') with fallback to es and finally to key
  const t = useMemo(() => {
    const tree = translations[lang] || translations.es;
    const fallback = translations.es;
    return (path) => {
      const parts = path.split('.');
      let cur = tree;
      let fb = fallback;
      for (const p of parts) {
        cur = cur?.[p];
        fb = fb?.[p];
      }
      if (cur !== undefined && cur !== null) return cur;
      if (fb !== undefined && fb !== null) return fb;
      return path;
    };
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
};
